import HomeComponent from './Home'
import AboutComponent from './About'
import ServicesComponent from './Services'
import ContactComponent from './Contact'
export default {
  HomeComponent,
  AboutComponent,
  ServicesComponent,
  ContactComponent
}



// WEBPACK FOOTER //
// ./src/components/index.js